var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_176",
    "data-name": "Raggruppa 176",
    transform: "translate(-320 -306)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_58",
    "data-name": "Ellisse 58",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    transform: "translate(320 306)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_177",
    "data-name": "Raggruppa 177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_955",
    "data-name": "Tracciato 955",
    d: "M-7400.207,12496.419l-14.209,13.24",
    transform: "translate(7744.812 -12179.539)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1015",
    "data-name": "Tracciato 1015",
    d: "M-7414.416,12496.419l14.209,13.24",
    transform: "translate(7744.811 -12179.539)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModalIcon);
export default __webpack_public_path__ + "static/media/close-modal-icon.939d963a41150810fab0df0c43fba07a.svg";
export { ForwardRef as ReactComponent };